import { getCurrentUTCTime, getDate } from "../utils/Utilities";

export interface TicketProps {
    flyer: string;
    goTo: string;
    ticketLink: string;
    ticketEvent: string;
    tablesLink: string;
    locationLink: string;
    showSince: string;
    showUntil: number;
    disabled?: boolean
}

interface IntroTextsProps {
    wantMyTicketAndMoreInfoIntroduction: TicketProps;
}

interface GlobalTextsProps {
    tickets: TicketProps[];
    ticketsInterior: TicketProps[];
    ticketsGba: TicketProps[];
    ticketsMdq: TicketProps[];
    whatsAppGroupLink: string;
    instagramLink: string;
    tiktokLink: string;
    twitterLink: string;
    spotifyLink: string;
    picturesLink: string;
}

export const globalTexts: GlobalTextsProps = {
    tickets: [
        {
            flyer: '220225-cruza-polo.webp',
            goTo: '220225-cruza',
            ticketLink: 'https://www.passline.com/eventos/fiebre-en-cruza-polo-222',
            ticketEvent: '22/02/25_cruza_polo',
            tablesLink: 'https://wa.me/message/FFDFCLWPF7KPB1',
            locationLink: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3285.372411272314!2d-58.43198067253831!3d-34.56944228576349!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcb57ef0e17391%3A0x1eaba36a56f16fe2!2sCruza%20Polo!5e0!3m2!1ses!2sar!4v1732920267412!5m2!1ses!2sar',
            showSince: '2024-11-29T22:59:00Z',
            showUntil: 20250222
        },
        {
            flyer: '050925-black.webp',
            goTo: '050925-black',
            ticketLink: 'https://www.passline.com/eventos/fiebre-fiesta-en-black-59/7-683010',
            ticketEvent: '05/09/25_black',
            tablesLink: 'https://wa.me/message/FFDFCLWPF7KPB1',
            locationLink: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3285.874584080714!2d-58.4483721!3d-34.556730699999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcb5eb0d0f6a89%3A0x64f7cfb36b48c654!2sBlack!5e0!3m2!1ses!2sar!4v1716311869803!5m2!1ses!2sar',
            showSince: '2025-05-28T00:00:00Z',
            showUntil: 20250905
        },
        {
            flyer: '120925-black.webp',
            goTo: '120925-black',
            ticketLink: 'https://www.passline.com/eventos/fiebre-fiesta-en-black-129/7-683010',
            ticketEvent: '12/09/25_black',
            tablesLink: 'https://wa.me/messat on ge/FFDFCLWPF7KPB1',
            locationLink: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3285.874584080714!2d-58.4483721!3d-34.556730699999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcb5eb0d0f6a89%3A0x64f7cfb36b48c654!2sBlack!5e0!3m2!1ses!2sar!4v1716311869803!5m2!1ses!2sar',
            showSince: '2025-05-28T00:00:00Z',
            showUntil: 20250912
        },
        {
            flyer: '260925-groove.webp',
            goTo: '260925-groove',
            ticketLink: 'https://www.passline.com/eventos/fiebre-fiesta-en-groove-269/7-483719',
            ticketEvent: '26/09/25_groove',
            tablesLink: 'https://wa.me/message/FFDFCLWPF7KPB1',
            locationLink: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3284.9688531391407!2d-58.4257572874254!3d-34.57965465611708!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcb59b4e07a685%3A0x57be92636048e0f9!2sGroove!5e0!3m2!1ses!2sar!4v1720909728659!5m2!1ses!2sar',
            showSince: '2025-07-04T15:00:00Z',
            showUntil: 20250926
        },
        {
            flyer: '071125-black.webp',
            goTo: '071125-black',
            ticketLink: 'https://www.passline.com/eventos/fiebre-fiesta-en-black-711/7-683010',
            ticketEvent: '07/11/25_black',
            locationLink: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3285.874584080714!2d-58.4483721!3d-34.556730699999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcb5eb0d0f6a89%3A0x64f7cfb36b48c654!2sBlack!5e0!3m2!1ses!2sar!4v1716311869803!5m2!1ses!2sar',
            tablesLink: 'https://wa.me/message/FFDFCLWPF7KPB1',
            showSince: '2025-06-12T23:00:00Z',
            showUntil: 20251107
        },
        {
            flyer: '221125-groove.webp',
            goTo: '221125-groove',
            ticketLink: 'https://www.passline.com/eventos/fiebre-fiesta-en-groove-2211-443671/7-483719',
            ticketEvent: '22/11/25_groove',
            tablesLink: 'https://wa.me/message/FFDFCLWPF7KPB1',
            locationLink: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3284.9688531391407!2d-58.4257572874254!3d-34.57965465611708!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcb59b4e07a685%3A0x57be92636048e0f9!2sGroove!5e0!3m2!1ses!2sar!4v1720909728659!5m2!1ses!2sar',
            showSince: '2025-07-04T15:00:00Z',
            showUntil: 20251122
        },
        {
            flyer: '191225-amk.webp',
            goTo: '191225-amk',
            ticketLink: 'https://www.passline.com/eventos/fiebre-fiesta-en-amerika-1912/7-683010',
            ticketEvent: '19/12/25_amk',
            tablesLink: 'https://wa.me/message/FFDFCLWPF7KPB1',
            locationLink: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3284.214426136018!2d-58.42625422321761!3d-34.59873897295616!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcca7b5b8847ff%3A0x181aac8b0ed8c2cf!2zQW3DqXJpa2E!5e0!3m2!1ses!2sar!4v1749767217341!5m2!1ses!2sar',
            showSince: '2025-06-12T23:00:00Z',
            showUntil: 20251219
        },
    ],
    ticketsGba: [
        {
            flyer: '281125-medusa.webp',
            goTo: '281125-medusa',
            ticketLink: 'https://www.passline.com/eventos/fiebre-fiesta-en-medusa-la-plata-2811/7-720787',
            ticketEvent: '28/11/25_medsa',
            tablesLink: 'https://wa.me/message/FFDFCLWPF7KPB1',
            locationLink: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3271.4298797189426!2d-57.9501864!3d-34.9207543!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95a2e723da762ac5%3A0xc441a55cd11e8add!2sMedusa!5e0!3m2!1ses!2sar!4v1761862854297!5m2!1ses!2sar',
            showSince: '2024-11-29T22:59:00Z',
            showUntil: 20251128
        },
        {
            flyer: '051225-feed2.webp',
            goTo: '051225-chinito',
            ticketLink: 'https://www.passline.com/eventos/fiebre-fiesta-en-chinito-0512/7-683010',
            ticketEvent: '07/12/25_chinito',
            locationLink: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3285.874584080714!2d-58.4483721!3d-34.556730699999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcb5eb0d0f6a89%3A0x64f7cfb36b48c654!2sBlack!5e0!3m2!1ses!2sar!4v1716311869803!5m2!1ses!2sar',
            tablesLink: 'https://wa.me/message/FFDFCLWPF7KPB1',
            showSince: '2025-11-06T23:00:00Z',
            showUntil: 20251205
        }
    ],
    ticketsInterior: [
        {
            flyer: '101025-taura.webp',
            goTo: '101025-taura',
            ticketLink: 'https://www.passline.com/eventos/fiebre-fiesta-en-taura-rosario-1010/7-683010',
            ticketEvent: '10/10/25_taura',
            tablesLink: 'https://wa.me/message/FFDFCLWPF7KPB1',
            locationLink: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d836.9995957918236!2d-60.62779222399837!3d-32.951052094093725!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95b7aafd220cd939%3A0x3674002ccf2d0399!2sComunidad%20Foral%20de%20Navarra%2080%2C%20S2000%20Rosario%2C%20Santa%20Fe!5e0!3m2!1ses!2sar!4v1759340772353!5m2!1ses!2sar',
            showSince: '2024-11-29T22:59:00Z',
            showUntil: 20251010
        },
        {
            flyer: '141125-vlack.webp',
            goTo: '141125-vlack',
            ticketLink: 'https://www.passline.com/eventos/fiebre-fiesta-en-cordoba-1411/7-683010',
            ticketEvent: '14/11/25_vlack',
            tablesLink: 'https://wa.me/message/FFDFCLWPF7KPB1',
            locationLink: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2272.380125121868!2d-64.19295656674262!3d-31.421752224062963!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9432a3998b529883%3A0x71b89400e19d9ef0!2zVkzOm0NL!5e0!3m2!1ses!2sar!4v1760470478491!5m2!1ses!2sar',
            showSince: '2024-11-29T22:59:00Z',
            showUntil: 20251114
        }
    ],
    ticketsMdq: [
        {
            flyer: '220126-mdq.webp',
            goTo: '220126-mdq',
            ticketLink: 'https://venti.com.ar/evento/fiebre-x-umn-jue-22-ene/web',
            ticketEvent: '22/01/26_mdq',
            tablesLink: 'https://wa.me/message/FFDFCLWPF7KPB1',
            locationLink: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d836.9995957918236!2d-60.62779222399837!3d-32.951052094093725!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95b7aafd220cd939%3A0x3674002ccf2d0399!2sComunidad%20Foral%20de%20Navarra%2080%2C%20S2000%20Rosario%2C%20Santa%20Fe!5e0!3m2!1ses!2sar!4v1759340772353!5m2!1ses!2sar',
            showSince: '2024-11-29T22:59:00Z',
            showUntil: 20260122
        },

    ],
    whatsAppGroupLink: 'https://chat.whatsapp.com/DvTmBLdUjh4KGyb4g3ATdq',
    instagramLink: 'https://www.instagram.com/fiebreflow/',
    tiktokLink: 'https://www.tiktok.com/@fiebre.fiesta',
    twitterLink: 'https://twitter.com/fiebrefiesta',
    spotifyLink: 'https://open.spotify.com/playlist/1H3SYVXxljbApZxgIWxh2U?si=a54WonX9SryzjMi49JSEGg&pi=u-fMQTIWKFRTay',
    picturesLink: 'https://drive.google.com/drive/folders/1dlI4mi7Fxb6Z0O9mF5-LkmpyalajPLyx?usp=share_link',
}

const getInfoVisible = (list: TicketProps[]) => {

    let index = 0

    const targetTimeUTC = new Date(list[index].showSince);

    const currentTimeUTC = new Date(getCurrentUTCTime());

    if ((list[index].showUntil < parseInt(getDate())) || ((currentTimeUTC < targetTimeUTC))) {
        index++
    }

    return list[index]

}

export const introTexts: IntroTextsProps = {
    wantMyTicketAndMoreInfoIntroduction: getInfoVisible([...globalTexts.tickets, ...globalTexts.ticketsGba, ...globalTexts.ticketsInterior]),
    // wantMyTicketAndMoreInfoIntroduction: globalTexts.tickets[0],
}